import { useQuery } from '@tanstack/react-query';

import { signupApi } from '../api/signup.adapter';

export const signupQueryKeys = {
  all: ['signup'] as const,
  invitation: (token: string) => [...signupQueryKeys.all, 'invitation', token] as const,
  terms: (token: string) => [...signupQueryKeys.all, 'terms', token] as const,
};

// Fetches the invitation metadata bound to the URL token (PRD 19 §3.2 / §3.3).
// `enabled = !!token` so we don't fire when the URL is missing the token.
// retry: false — a 410/409 from this call drives the page state; retrying would
// mask the expired / already-registered branches.
export function useSignupInvitationQuery(token: string | null) {
  return useQuery({
    queryKey: signupQueryKeys.invitation(token ?? ''),
    queryFn: () => signupApi.verifyInvitation(token ?? ''),
    enabled: !!token,
    retry: false,
    staleTime: 0,
  });
}
